import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Banner.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Banner.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {ComponentChildren} [icon]
 * @property {ComponentChildren} [children]
 * @property {"info" | "success" | "error" | "warning"} [kind ="info"] Default is `"info"`
 * @property {"shake"} [animate]
 */

/** @param {Props} props */
export default function Banner(props) {
  const {
    icon,
    children,
    kind,
    animate
  } = props;
  return __h("div", {
    "class": css.banner,
    "data-kind": kind,
    "data-animate": animate,
    role: "status"
  }, icon, __h("span", {}, children));
}